import {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice,
  IconFriends
} from '@tabler/icons';
import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';

const icons = {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice,
  IconFriends
};

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const customermgmt = {
  id: 'pages',
  title: 'Membership',
  type: 'group',
  children: [
    {
      id: 'customer',
      title: 'Members',
      type: 'item',
      url: '/dashboard/client',
      icon: getIcon(peopleFill),
      breadcrumbs: false
    },
    {
      id: 'membMgmt',
      title: 'Member Management',
      type: 'collapse',
      icon: icons.IconFriends,
      children: [
        {
          id: 'ssbproc',
          title: 'Submit SSB',
          type: 'item',
          url: '/accounts/selectssb',
          target: false
        },
        {
          id: 'webapp',
          title: 'Web Applications',
          type: 'item',
          url: '/clientportfolio/webapplications',
          target: false
        },
        {
          id: 'pendingsubs',
          title: 'Pending Submission',
          type: 'item',
          url: '/ssb/pendingsubmission',
          breadcrumbs: false
        },
        {
          id: 'provincessb',
          title: 'Province Ssb Upload',
          type: 'item',
          url: '/ssb/provincessb',
          target: false
        },
        {
          id: 'registermember',
          title: 'Register Internal',
          type: 'item',
          url: '/ssb/registerinternal',
          breadcrumbs: false
        },
        {
          id: 'addDep',
          title: 'Add Dependants',
          type: 'item',
          url: '/clientportfolio/adddependant',
          breadcrumbs: false
        },
        {
          id: 'taskschedule',
          title: 'Task Scheduler',
          type: 'item',
          url: '/settings/scheduler',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'subs',
      title: 'Subscriptions',
      type: 'collapse',
      icon: icons.IconBusinessplan,
      children: [
        // {
        //   id: 'extractFil',
        //   title: 'Receipts - Current File',
        //   type: 'item',
        //   url: '/accounts/extractssb',
        //   target: false
        // },
        // {
        //   id: 'historyFile',
        //   title: 'Receipts - Old File',
        //   type: 'item',
        //   url: '/ssb/bulkbilldetails',
        //   target: false
        // },
        {
          id: 'processRec',
          title: 'SSB Process Files',
          type: 'item',
          url: '/accounts/receiptfile',
          target: false
        },
        {
          id: 'changefile',
          title: 'SSB Change Files',
          type: 'item',
          url: '/ssb/changefile',
          target: false
        },
        {
          id: 'processBills',
          title: 'Monthly Bill Subs',
          type: 'item',
          url: '/accounts/selectbill',
          target: false
        },
        {
          id: 'fileLooksup',
          title: 'File Lookup View',
          type: 'item',
          url: '/ssb/filesinfo',
          target: false
        },
        {
          id: 'extraRec',
          title: 'Individual Receipts',
          type: 'item',
          url: '/accounts/extrareceipt',
          target: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'extraSumRec',
          title: 'Receipt Summary',
          type: 'item',
          url: '/reportsnew/receiptlist',
          target: false
        },
        {
          id: 'defaults',
          title: 'Unpaid Subs',
          type: 'item',
          url: '/ssb/defaults',
          target: false
        },
        {
          id: 'memberSummary',
          title: 'Member Summary',
          type: 'item',
          url: '/membershipreports/bysummary',
          target: false
        },
        {
          id: 'memberBala',
          title: 'File Reports',
          type: 'item',
          url: '/reports/fileReport',
          target: false
        },
        {
          id: 'memberprovince',
          title: 'Members By Province',
          type: 'item',
          url: '/membershipreports/byprovince',
          breadcrumbs: false
        },
        {
          id: 'memberdistrict',
          title: 'Members By District',
          type: 'item',
          url: '/membershipreports/bydistrict',
          breadcrumbs: false
        },
        {
          id: 'memberbreak',
          title: 'Members By District (2)',
          type: 'item',
          url: '/membershipreports/bybreakdown',
          breadcrumbs: false
        },

        {
          id: 'memberage',
          title: 'Members By Age',
          type: 'item',
          url: '/membershipreports/byage',
          breadcrumbs: false
        },
        {
          id: 'retire',
          title: 'By Retirement',
          type: 'item',
          url: '/membershipreports/byretire',
          breadcrumbs: false
        },
        {
          id: 'provincefiles',
          title: 'Monthly Files',
          type: 'item',
          url: '/membershipreports/byprovincefile',
          breadcrumbs: false
        },
        {
          id: 'membership',
          title: 'Full Membership',
          type: 'item',
          url: '/reports/fullmembership',
          breadcrumbs: false
        },
        {
          id: 'memberchanges',
          title: 'Membership Changes',
          type: 'item',
          url: '/reports/membershipchanges',
          breadcrumbs: false
        },
        {
          id: 'membershipstats',
          title: 'Membership Stats',
          type: 'item',
          url: '/reports/membershipstats',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'collapse',
      icon: icons.IconSettings,
      children: [
        {
          id: 'templates',
          title: 'Comm Templates',
          type: 'item',
          url: '/settings/templates',
          breadcrumbs: false
        },
        {
          id: 'paycycles',
          title: 'Cycle Management',
          type: 'item',
          url: '/settings/cyclemgmt',
          breadcrumbs: false
        },
        {
          id: 'ssbCodes',
          title: 'SSB Codes',
          type: 'item',
          url: '/settings/ssbcodes',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default customermgmt;
